import { ContentSidePadding } from "components/ContentSidePadding";
import { ChampionHomePage } from "@ugg/shared/components/Champions/pages/Home/ChampionHomePage";
import { RampLeftRail, RampRightRail } from "components/Ads/RampRails";
import { MediaQuery } from "@outplayed/responsive";

export function ChampionsPage() {
  return (
    <div className="flex justify-center mx-auto w-full max-md:w-full">
      <MediaQuery min="DESKTOP_SMALL" max="DESKTOP_LARGE" renderNullOnFail isClient>
        <div className="flex-1 min-w-0 mr-[-12px]">
          <RampLeftRail className="sticky top-[calc(var(--masthead-height)+100px)] transition-[top]" />
        </div>
      </MediaQuery>
      <ContentSidePadding className="mx-auto w-[1016px] max-md:w-full box-content">
        <ChampionHomePage />
      </ContentSidePadding>
      <MediaQuery min="DESKTOP_SMALL" max="DESKTOP_LARGE" renderNullOnFail isClient>
        <div className="flex-1 min-w-0 ml-[-12px]">
          <RampRightRail className="sticky top-[calc(var(--masthead-height)+100px)] transition-[top]" />
        </div>
      </MediaQuery>
    </div>
  );
}
